<template lang="html">
    <div class="vx-card p-6">
        <div class="flex justify-end">
            <vs-button color="primary" icon-pack="feather" icon="icon-plus" type="border" @click="clearValue">
                Thêm mới
            </vs-button>
        </div>
        <vs-collapse>
            <vs-collapse-item accordion v-for="(data, ind) in dataTemplate" :key="ind">
                <div slot="header" @click="toggleCategory(data.id)"
                    class="header-container flex items-center cursor-pointer justify-between ">
                    <span class="hover:text-primary">{{ data.title }}</span>
                    <div class="icons-container flex items-center">
                        <span @click.stop="deleteEmailTemplateDetails(data.id)">
                            <vx-tooltip class="position-icon mr-2" :text="$t('button.delete')" position="top">
                                <feather-icon svg-classes="h-4 w-6" icon="TrashIcon" color="primary"
                                    class="password-toggle hover:text-primary"></feather-icon>
                            </vx-tooltip>
                        </span>
                        <span @click.stop="checkPopupaddEmailItem(data.id)">
                            <vx-tooltip class="position-icon mr-2" :text="$t('button.create')" position="top">
                                <feather-icon svg-classes="h-4 w-6" icon="PlusCircleIcon" color="primary"
                                    class="password-toggle hover:text-primary"></feather-icon>
                            </vx-tooltip>
                        </span>
                    </div>
                </div>
                <vs-list v-for="(email, ind) in emailItems" :key="ind">
                    <vs-list-item title="Nội dung chi tiết" :subtitle="email.title"></vs-list-item>

                </vs-list>

            </vs-collapse-item>
        </vs-collapse>
        <vs-popup title="Thêm mới email" :active.sync="openPopupaddEmail">
            <div class="vx-col md:w-full">
                <label class="vs-input--label required"> {{ $t('tasks.title') }}</label><br />
                <vs-input class="w-full" v-model="formAdd.title" />
            </div>
            <div class="vx-col md:w-full">
                <label class="vs-input--label required"> Vị trí</label><br />
                <vs-input class="w-full" v-model="formAdd.order" />
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-4">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="mr-5" @click="addEmailTemplate">Thêm mới</vs-button>
                        <vs-button class="" color="danger" type="border" @click="openPopupaddEmail = false">{{
                $t('tasks.close')
            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
        <vs-popup title="Thêm mới" :active.sync="openPopupaddEmailItem">
            <div class="vx-col md:w-full">
                <label class="vs-input--label required"> {{ $t('tasks.title') }}</label><br />
                <vs-input class="w-full" v-model="formAddItem.title" />
            </div>
            <div class="vx-col md:w-full">
                <label class="vs-input--label required"> Vị trí</label><br />
                <vs-input class="w-full" v-model="formAddItem.order" />
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-4">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="mr-5" @click="addEmailTemplateItem(id)">Thêm mới</vs-button>
                        <vs-button class="" color="danger" type="border" @click="openPopupaddEmailItem = false">{{
                $t('tasks.close')
                            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

    </div>
</template>
<script>
import vSelect from "vue-select";


export default {
    components: {
        vSelect,
    },
    data() {
        return {
            openPopupaddEmail: false,
            openPopupaddEmailItem: false,
            emailItems: [
            ],
            isActive: null,
            formAdd: {
                title: '',
                order: '',
                organizationId: ''
            },
            formAddItem: {
                title: '',
                order: '',
                organizationId: '',
                templateId: '',
            },
            organizationId: 'null',
            dataTemplate: [],
            dataTemplateId: null,
            ids:[],
        };
    },
    created() {
        this.getEmailTemplate();
    },
    methods: {
        clearValue() {
            this.formAdd.title = '';
            this.formAdd.order = '';
            this.formAdd.organizationId = '';
            this.openPopupaddEmail = true;

        },
        toggleCategory(id) {
            this.isActive = id
            this.getEmailTemplateDetail(id);
        },
        isCategoryOpen(category) {
            return this.openCategory === category;
        },
        checkPopupaddEmailItem(id) {
            this.formAddItem.templateId = id;
            this.openPopupaddEmailItem = true;
        },
        getEmailTemplate() {
            this.organizationId = JSON.parse(localStorage.getItem("userInfo"));
            this.formAddItem.organizationId = this.organizationId.organization.id
            this.$vs.loading()
            this.$crm.get(`/setting/email-template/find-by-organization-id`).then((response) => {
                this.$vs.loading.close()
                this.dataTemplate = response.data
            })
        },
        addEmailTemplate() {
            this.formAdd.organizationId = this.organizationId.organization.id,
                this.$vs.loading()
            this.$crm.post(`/setting/email-template/create`, this.formAdd).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Tạo mới thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.openPopupaddEmail = false
                this.getEmailTemplate();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },
        addEmailTemplateItem() {
            this.$vs.loading()
            this.$crm.post(`/setting/email-template-detail/create`, this.formAddItem).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Tạo mới thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.openPopupaddEmailItem = false
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },
        deleteEmailTemplateDetails(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa mục này không ?`,
                accept: () => this.acceptDelete(id),
                acceptText: "Xóa",
                cancelText: "Huỷ"

            })
        },
        acceptDelete(id) {
            this.$vs.loading()
            this.$crm.delete(`/setting/email-template/delete/${id}`).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Xóa thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.openPopupaddEmailItem = false
                this.getEmailTemplate()
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Gặp lỗi khi xóa',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },
        getEmailTemplateDetail(id) {
            // this.dataTemplate.map(el => {
            //      this.ids = el.id
            // })
            this.$vs.loading()
            this.$crm.get(`/setting/email-template-detail/find-by-template-id/${id}`).then((response) => {
                this.$vs.loading.close()
                this.emailItems = response.data
            })
        },
    }
};
</script>
<style scoped>
.no-border {
    border: none;
    outline: none;
    background-color: #f0f0f0;
    border-radius: 6px;
}

input {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
}

.email-item:hover {
    background-color: rgb(231, 224, 224);
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.icons-container {
    display: flex;
    align-items: center;
}
</style>
